<header>
    <mat-toolbar class="shadow primary-bg-color ps-0" [ngClass]="{'position-relative': isMobile}">
        <div class="ms-md-5" [ngClass]="{'position-absolute top-50 start-50 translate-middle': isMobile}">
          <a href="https://liverpool.com.mx/tienda/home"><img id="logo"/></a>
        </div>
      
        <span class="spacer"></span>
        <div class="d-none d-sm-none d-md-block" style="margin-right:3%;">  
          <span class="spacer"></span>
          <div class="popover__wrapper d-none d-sm-none d-md-block" >
            <a href="#" style="font-size:14px;font-weight:normal;cursor:pointer;color:white;text-decoration: none;">
              {{ 'MAS_GARANTIA_HEADER.LABEL1' | translate }} {{this.storageService.getData('userName')}} <fa-icon [icon]="faAngleDown" class="fa-solid fa-angle-down"></fa-icon>
            </a>
            <div class="popover__content">
              <a href="https://www.liverpool.com.mx/tienda/users/myAccount" class="text-muted d-block mb-2" style="font-size:14px;font-weight:normal;text-decoration: none;"> {{ 'MAS_GARANTIA_HEADER.LABEL2' | translate }} </a>
              <a href="https://www.liverpool.com.mx/tienda/users/miscompras" class="text-muted d-block mb-2" style="font-size:14px;font-weight:normal;text-decoration: none;"> {{ 'MAS_GARANTIA_HEADER.LABEL3' | translate }} </a>
              <a href="" class="text-muted d-block mb-2" style="font-size:14px;font-weight:normal;text-decoration: none;"> {{ 'MAS_GARANTIA_HEADER.LABEL4' | translate }} </a>
              <a href="https://www.liverpool.com.mx/tienda/users/coupons" class="text-muted d-block mb-2" style="font-size:14px;font-weight:normal;text-decoration: none;"> {{ 'MAS_GARANTIA_HEADER.LABEL5' | translate }} </a>
              <a href="" class="text-muted d-block mb-2" style="font-size:14px;font-weight:normal;text-decoration: none;"> {{ 'MAS_GARANTIA_HEADER.LABEL6' | translate }} </a>
              <a class="text-muted d-block" style="font-size:14px;font-weight:normal;text-decoration: none;" (click)="logOut()"> {{ 'MAS_GARANTIA_HEADER.LABEL7' | translate }} </a>
            </div>
          </div>
        </div>
      <!-- <div style="margin-right:3%">
        <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
          <div style="font-size: 10px; position: absolute; top: -15px; width: 100%;"> Ayuda</div>
          <i class="fa-solid fa-circle-question"></i>
        </button>
      </div> -->
    </mat-toolbar>
</header>